

<script>
// CommitChart.js
import { Line ,mixins } from 'vue-chartjs';
import zoom from 'chartjs-plugin-zoom'
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.addPlugin(zoom);
    this.renderLineChart();
  },
  methods: {
    renderLineChart() {
      this.renderChart(this.chartData, this.options)
    }
  },
  watch: {
    data: function() {

      console.log("DATA CHANGED");
      this.$data._chart.destroy();
      this.renderLineChart();
      this.$data._chart.resetZoom();
    }
  }

}

</script>